import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Loader2, Wrench } from 'lucide-react';

export const SettingsSection = ({
  maintenanceMode,
  maintenanceTitle,
  setMaintenanceTitle,
  maintenanceMessage,
  setMaintenanceMessage,
  maintenanceEta,
  setMaintenanceEta,
  onToggleMaintenance,
  onSaveMaintenanceTexts,
  savingMaintenance,
}) => (
  <div className="space-y-6" data-testid="admin-settings">
    <div className={`rounded-2xl border-2 p-6 ${maintenanceMode ? 'bg-amber-50 border-amber-300' : 'bg-white border-gray-100'}`} data-testid="maintenance-settings">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${maintenanceMode ? 'bg-amber-500' : 'bg-gray-100'}`}>
            <Wrench className={`h-5 w-5 ${maintenanceMode ? 'text-white' : 'text-gray-500'}`} />
          </div>
          <div>
            <h3 className="font-bold text-[#0F172A]">Underhållsläge</h3>
            <p className="text-sm text-gray-500">
              {maintenanceMode ? 'Aktivt — Endast admin kan se sidan' : 'Inaktivt — Sidan är publik'}
            </p>
          </div>
        </div>
        <Button
          onClick={onToggleMaintenance}
          disabled={savingMaintenance}
          variant={maintenanceMode ? 'destructive' : 'default'}
          className={maintenanceMode ? '' : 'bg-amber-500 hover:bg-amber-600'}
          data-testid="toggle-maintenance-btn"
        >
          {savingMaintenance && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
          {maintenanceMode ? 'Avaktivera' : 'Aktivera'}
        </Button>
      </div>

      <div className={`mt-4 pt-4 border-t ${maintenanceMode ? 'border-amber-200' : 'border-gray-100'}`}>
        <p className="text-sm font-medium text-gray-700 mb-4">
          Texter på underhållssidan (visas för besökare när läget är aktivt)
        </p>
        <div className="space-y-4">
          <div>
            <Label htmlFor="maint-title" className="text-sm font-medium text-gray-700">Huvudrubrik</Label>
            <Input
              id="maint-title"
              value={maintenanceTitle}
              onChange={(e) => setMaintenanceTitle(e.target.value)}
              placeholder="Underhållsarbete pågår"
              className={`mt-1.5 ${maintenanceMode ? 'border-amber-300' : ''}`}
              data-testid="maintenance-title-input"
            />
          </div>
          <div>
            <Label htmlFor="maint-body" className="text-sm font-medium text-gray-700">Brödtext</Label>
            <Textarea
              id="maint-body"
              value={maintenanceMessage}
              onChange={(e) => setMaintenanceMessage(e.target.value)}
              placeholder="Vi uppdaterar plattformen…"
              rows={4}
              className={`mt-1.5 resize-y min-h-[100px] ${maintenanceMode ? 'border-amber-300' : ''}`}
              data-testid="maintenance-message-input"
            />
          </div>
          <div>
            <Label htmlFor="maint-eta" className="text-sm font-medium text-gray-700">Beräknad tid</Label>
            <p className="text-xs text-gray-500 mt-0.5 mb-1">Visas som: Beräknad tid: …</p>
            <Input
              id="maint-eta"
              value={maintenanceEta}
              onChange={(e) => setMaintenanceEta(e.target.value)}
              placeholder="Några minuter"
              className={`mt-1 ${maintenanceMode ? 'border-amber-300' : ''}`}
              data-testid="maintenance-eta-input"
            />
          </div>
          <Button
            type="button"
            variant="outline"
            onClick={onSaveMaintenanceTexts}
            disabled={savingMaintenance}
            data-testid="save-maintenance-texts-btn"
          >
            {savingMaintenance && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            Spara texter
          </Button>
        </div>
      </div>
    </div>
  </div>
);
